import { palettes, tints } from '@manychat/manyui'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '24px',
  borderRadius: '16px',
  padding: '22px 0',
  border: `2px solid ${tints.blue[3]}`,
  borderStyle: 'dashed',
  borderDashStyle: '7px 5px',
}

export const BtnHoverStyle = {
  ...BtnStyle,
  background: tints.blue[6],
}

export const BtnWithTriggersStyle = {
  ...BtnStyle,
  borderColor: palettes.typography.border,
}

export const BtnCaptionStyle = {
  ...sharedStyles.subheading,
  color: tints.blue[3],
}
export const BtnHoverCaptionStyle = {
  ...sharedStyles.subheading,
  color: tints.blue[3],
}
